import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Subscription } from "rxjs/Subscription";
import { TitleCasePipe } from "@angular/common";

import { PackService } from "@edp-services/pack.service";
import { PackSubscriberService } from "@edp-services/pack-subscriber.service";
import { Discount, DiscountConditionForm } from "@edp-components/edp-pack-discount";
import { Contract } from "@edp-components/edp-contract";
import { IBillingData } from "@edp-models/edp-pack-subscriber.model";
import { EmailValidator } from "@edp-validators/email.validator";
import { IbanValidator } from "@edp-validators/iban.validator";
import { BillingAddressModel } from "@edp-components/edp-contract/edp-contract.model";

@Component({
    selector: "edp-discount-form",
    templateUrl: "./edp-discount-form.component.html",
    styleUrls: ["./edp-discount-form.component.scss"],
})
export class EdpDiscountFormComponent implements OnInit, OnDestroy {
    @Input() contract: Contract;
    private subscriptions: Subscription[] = [];
    public form: FormGroup;
    public discount: Discount;
    public isSubmited = false;

    constructor(
        private formBuilder: FormBuilder,
        private packService: PackService,
        private packSubscriberService: PackSubscriberService,
        private titleCasePipe: TitleCasePipe
) {}

    ngOnInit() {
        const discountSubscription: Subscription = this.packService.discountChanged$.subscribe((discount: Discount) => {
            if (!discount.current) {
                this.discount = discount;
                this.form = this.createForm(discount);
            }
        });

        const packSubscription: Subscription = this.packSubscriberService.submitIntention$.subscribe((submited: boolean) => {
            if (this.form) {
                const billingData = !this.form.invalid ? this.form.value as IBillingData : false;
                this.isSubmited = submited;
                this.packSubscriberService.setBillingData(billingData);
            } else {
                this.packSubscriberService.setBillingData(true);
            }
        });

        this.subscriptions.push(discountSubscription);
        this.subscriptions.push(packSubscription);
    }

    ngOnDestroy() {
        this.subscriptions.forEach((subscription: Subscription) => subscription.unsubscribe());
    }

    private createForm(selectedDiscount: Discount): FormGroup {
        const formConditions: DiscountConditionForm = selectedDiscount.getForm();
        const fields: any = {};
        let form: FormGroup;

        if (formConditions.hasDirectDebit) {
            fields.iban = [this.contract.DirectDebitIban, [Validators.required, IbanValidator]];
        }

        if (formConditions.hasElectronicInvoice) {
            fields.email = [this.contract.ElectronicInvoiceEmail, [Validators.required, EmailValidator]];
        } else {
            fields.address = [{ value: this.createFullAddress(this.contract.BillingAddress), disabled: true}];
        }

        form = this.formBuilder.group(fields);

        return form;
    }

    private createFullAddress(addressObject: BillingAddressModel): string {
        const street = addressObject.Street ? `${this.titleCasePipe.transform(addressObject.Street)}, ` : "";
        const houseNumber = addressObject.HouseNumber ? `${addressObject.HouseNumber} - ` : "";
        const numberComplement = addressObject.NumberComplement ? `${addressObject.NumberComplement} - ` : "";
        const supplement = addressObject.Supplement ? `${addressObject.Supplement}, ` : "";
        const postalCode = addressObject.PostalCode ? `${addressObject.PostalCode}, ` : "";
        const location = addressObject.Location ? `${addressObject.Location}, ` : "";
        const city = addressObject.City ? `${this.titleCasePipe.transform(addressObject.City)}` : "";
        return `${street}${houseNumber}${numberComplement}${supplement}${postalCode}${location}${city}`;
    }

}
